module.exports = __webpack_public_path__ + "img/BITCOIN.d656a374.svg";